// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
import { IconArrowRampRight, IconChevronDown, IconChevronRight } from '@tabler/icons-react';
import { useState } from 'react';
import type { SynqoCondition, SynqoIfThenElseCondition, SynqoRuleset } from '@Model';
import { ACCENT } from './accent';
import { ConditionCard } from './ConditionCard';
import { ConditionVisitor } from './ConditionVisitor';

interface IfThenElseRendererProps {
    node: SynqoIfThenElseCondition;
    referencedRulesets: Record<string, SynqoRuleset>;
}

export function IfThenElseRenderer({ node, referencedRulesets }: IfThenElseRendererProps) {
    return (
        <ConditionCard accent={ACCENT.if_then_else}>
            <div className="flex items-center gap-2 text-sm text-(--mantine-color-text-5)">
                <IconArrowRampRight size={16} className={`shrink-0 ${ACCENT.if_then_else.icon}`} />
                <span className="text-(--mantine-color-primary-text) font-semibold">Bedingte Prüfung</span>
            </div>
            <div className="mt-2 flex flex-col gap-2">
                <IfThenElseSection label="Wenn" child={node.if} referencedRulesets={referencedRulesets} />
                <IfThenElseSection label="Dann" child={node.then} referencedRulesets={referencedRulesets} />
                {node.else && (
                    <IfThenElseSection label="Sonst" child={node.else} referencedRulesets={referencedRulesets} />
                )}
            </div>
        </ConditionCard>
    );
}

interface IfThenElseSectionProps {
    label: string;
    child: SynqoCondition;
    referencedRulesets: Record<string, SynqoRuleset>;
}

function IfThenElseSection({ label, child, referencedRulesets }: IfThenElseSectionProps) {
    const [expanded, setExpanded] = useState(true);
    return (
        <div className="rounded border border-(--mantine-color-outline-5) bg-(--mantine-color-secondary-0) p-2">
            <button
                type="button"
                onClick={() => setExpanded((prev) => !prev)}
                className="flex w-full items-center gap-1 text-left text-sm hover:text-(--mantine-color-text-7)"
                aria-expanded={expanded}
            >
                {expanded ? (
                    <IconChevronDown size={14} className="shrink-0 text-(--mantine-color-text-4)" />
                ) : (
                    <IconChevronRight size={14} className="shrink-0 text-(--mantine-color-text-4)" />
                )}
                <span className="text-(--mantine-color-primary-text) font-semibold">{label}</span>
            </button>
            {expanded && (
                <div className="mt-2 pl-1">
                    <ConditionVisitor node={child} referencedRulesets={referencedRulesets} />
                </div>
            )}
        </div>
    );
}
